import { ReactNode, createContext } from 'react';

export type EnvironmentUrls = {
  // Bank / credit-card logo images are served from <embedAssetsUrl>/images/...
  embedAssetsUrl: string;
  // Where eLinx sends the customer back to when a request generated by shared finishes.
  elinxRedirectUrl: string;
};

export type EnvironmentUrlsProviderProps = {
  environmentUrls: EnvironmentUrls;
  children: ReactNode;
};

export const EnvironmentUrlsContext = createContext<EnvironmentUrls | null>(null);
